import { QueryClientProvider } from "@tanstack/react-query";
import { RouterProvider, createRouter } from "@tanstack/react-router";
import { StrictMode } from "react";
import ReactDOM from "react-dom/client";

import { queryClient } from "~/lib/query-client";
import { initializeAppearance } from "~/modules/appearance/store";
import { loginCredentials } from "~/modules/auth/credentials";
import { routeTree } from "~/routeTree.gen";

import "~/styles.css";

let appearanceUserId: string | null = null;
try {
  appearanceUserId = loginCredentials.get()?.userId ?? null;
} catch {
  appearanceUserId = null;
}
const disposeAppearance = initializeAppearance(appearanceUserId);
import.meta.hot?.dispose(disposeAppearance);

// Create a new router instance
const router = createRouter({
  routeTree,
  context: { queryClient },
  defaultPreload: "intent",
  scrollRestoration: true,
  defaultStructuralSharing: true,
  defaultPreloadStaleTime: 0,
});

// Register the router instance for type safety
declare module "@tanstack/react-router" {
  interface Register {
    router: typeof router;
  }
}

// Render the app
const rootElement = document.getElementById("app");
if (rootElement && !rootElement.innerHTML) {
  const root = ReactDOM.createRoot(rootElement);
  root.render(
    <StrictMode>
      <QueryClientProvider client={queryClient}>
        <RouterProvider router={router} />
      </QueryClientProvider>
    </StrictMode>
  );
}
